import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { type PayGatePaymentModuleSpecsFragment } from '../../../../api/fragments/PayGatePaymentModuleSpecs';
import NoItemResult from '../../../../components/results/NoItemResult';
import { usePayGatePaymentSettingsDrawer } from './PayGatePaymentSettingsDrawer';

export type PayGatePaymentSettingsEmptyListProps = {
    module: PayGatePaymentModuleSpecsFragment;
};

const PayGatePaymentSettingsEmptyList = ({ module }: PayGatePaymentSettingsEmptyListProps) => {
    const { t } = useTranslation(['paygatePaymentModuleDetails']);
    const addPayGatePaymentSettingsDrawer = usePayGatePaymentSettingsDrawer(module.id);

    return (
        <>
            <NoItemResult
                extra={
                    <Button onClick={addPayGatePaymentSettingsDrawer.open} type="primary">
                        {t('paygatePaymentModuleDetails:emptyList.paymentSettings.noData.action')}
                    </Button>
                }
                subTitle={t('paygatePaymentModuleDetails:emptyList.paymentSettings.noData.message')}
            />
            {addPayGatePaymentSettingsDrawer.render()}
        </>
    );
};

export default PayGatePaymentSettingsEmptyList;
